export default __webpack_public_path__ + "static/media/81.70e7b3e3.gif";